import firebase from "../firebase";

const db = firebase.ref("/comments");

class CommentsDataService {
  getAll() {
    return db;
  }

  create(comments) {
    return db.push(comments);
  }

  update(key, value) {
    return db.child(key).update(value);
  }

  delete(key) {
    return db.child(key).remove();
  }

  deleteAll() {
    return db.remove();
  }
}

export default new CommentsDataService();
